module.exports = __webpack_public_path__ + "img/portfolio-09-670x479.cd2e1ed4.jpg";